import React from 'react';
import { View } from 'react-native';

export const BannerAd = () => <View />;
export const TestIds = {};
export const AdEventType = {
  LOADED: 'loaded',
  CLOSED: 'closed'
};
export const BannerAdSize = {
  ANCHORED_ADAPTIVE_BANNER: 'ANCHORED_ADAPTIVE_BANNER',
  MEDIUM_RECTANGLE: 'MEDIUM_RECTANGLE'
};

const createAdStub = () => ({
  load: () => {},
  show: () => {},
  addAdEventListener: () => () => {},
  removeAllListeners: () => {}
});

export const AppOpenAd = {
  createForAdRequest: () => createAdStub()
};

export const InterstitialAd = {
  createForAdRequest: () => createAdStub()
};

const mobileAds = () => ({
  initialize: async () => undefined,
  setRequestConfiguration: async () => undefined
});

export default mobileAds;
